type SectionInfoProps = {
  title: string
  secondLabel: string
  thirdLabel: string
  fourthLabel?: string
}

const SectionInfo = ({ title, secondLabel, thirdLabel, fourthLabel }: SectionInfoProps) => {
  return (
    <div className="flex flex-col gap-1 typography-body-l text-primary-800">
      <h6 className="typography-body-xl font-bold">{title}</h6>
      <p>{secondLabel}</p>
      <p>{thirdLabel}</p>
      {!!fourthLabel && <p>{fourthLabel}</p>}
    </div>
  )
}

export default SectionInfo
